import * as R from 'ramda';
import AddressInfo from '../addressInfo';
import {FrenchTypes} from '../../utils/connectionTypes';

export default function OtherActivity(data) {
    let activity = data || {};
    this.type = FrenchTypes.otherActivity;
    this.address = R.isNil(data) || R.isNil(data.address) ? new AddressInfo() : new AddressInfo(data.address);
    this.name =  activity.name;
    this.function =  activity.function;
}